import { render, staticRenderFns } from "./autoOptimizeDialog.vue?vue&type=template&id=cb0856d0&scoped=true"
import script from "./autoOptimizeDialog.vue?vue&type=script&lang=js"
export * from "./autoOptimizeDialog.vue?vue&type=script&lang=js"
import style0 from "./autoOptimizeDialog.vue?vue&type=style&index=0&id=cb0856d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb0856d0",
  null
  
)

export default component.exports